import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHandlerFn,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APIError } from '../models/apierror';

export function authInterceptor(
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> {
  const cookieService = inject(CookieService);

  req = req.clone({
    setHeaders: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
      Authorization: `Bearer ${cookieService.get('token')}`,
    },
  });

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      console.log(err);
      return throwError(() => {
        if (typeof err == 'string') return new APIError(err, -1, -1);
        if (err instanceof HttpErrorResponse)
          return new APIError(err.error.message, err.status, err.error.error);
        else return new APIError((err as any).toString(), -1, -1);
      });
    }),
  );

  /* return next.handle(req).pipe(
    catchError((error: HttpErrorResponse) => {
      var errret: any = error;
      errret.body = error.error;
      return of<any>(new HttpResponse(errret));
      //return throwError(error.error);
    })
  ); */
}
